
import Controller from "./controller";

let DistanceController = new Controller();

export {
    DistanceController
}
